import { useTranslation } from "react-i18next";
import { getVexSecuritiesBadgeState, VEX_SECURITIES_BADGE_STATE } from "@constants/vex";

const BADGE_STATE_CLASSES = {
  [VEX_SECURITIES_BADGE_STATE.COMPLETE]: "border-emerald-500/60 bg-emerald-500/20 text-emerald-300",
  [VEX_SECURITIES_BADGE_STATE.UNDER_INVESTIGATION]:
    "border-orange-500/60 bg-orange-500/20 text-orange-300",
  [VEX_SECURITIES_BADGE_STATE.INCOMPLETE]: "border-red-500/60 bg-red-500/20 text-red-300",
};

const BADGE_STATE_TITLE_KEYS = {
  [VEX_SECURITIES_BADGE_STATE.COMPLETE]: "status.vex-securities-badge-complete-tooltip",
  [VEX_SECURITIES_BADGE_STATE.UNDER_INVESTIGATION]:
    "status.vex-securities-badge-under-investigation-tooltip",
  [VEX_SECURITIES_BADGE_STATE.INCOMPLETE]: "status.vex-progress-processed-tooltip",
};

/**
 * processed/total chip for a component's CVE review state.
 * Renders nothing when the component has no VEX entries.
 */
const VexSecuritiesBadge = ({ progress, onClick, "data-testid": dataTestId = "vex-securities-badge" }) => {
  const { t } = useTranslation();
  const badgeState = getVexSecuritiesBadgeState(progress);

  if (!badgeState) {
    return null;
  }

  return (
    <span
      onClick={onClick}
      className={`rounded px-1 py-0.5 text-[10px] font-bold leading-none whitespace-nowrap border ${
        BADGE_STATE_CLASSES[badgeState]
      }${onClick ? " cursor-pointer hover:opacity-80 transition-opacity" : ""}`}
      title={t(BADGE_STATE_TITLE_KEYS[badgeState])}
      data-testid={dataTestId}
    >
      {progress.processed}/{progress.total}
    </span>
  );
};

export default VexSecuritiesBadge;
